export function splitNumber(number, separator = ' ') {
  if (typeof number !== 'number') return 'undefined';

  let parts = number.toString().split('.');
  return (
    parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator) +
    (parts[1] ? '.' + parts[1] : '')
  );
}
